import { call, put } from 'redux-saga/effects';
import gql from 'graphql-tag';
import { appDataService } from '@flow/appsync-client';
import { setFavourites } from '@flow/graphql/mutations';
import { getFavourites } from '@flow/graphql/queries';
import { SET_FAVOURITES_ERROR, SET_FAVOURITES_SUCCESS } from '@flow/store/user/constants';


const ApiRequest = (favourites: Favourite[]) => {
  return appDataService.client.mutate({
    mutation: gql(setFavourites),
    variables: { favourites: favourites },
    refetchQueries: [
      {
        query: gql(getFavourites)
      }
    ]
  });
};

export function * setFavouritesFlow(favourites: Favourite[], onComplete?: (result: APICallResult) => any) {
  try {
    const response = yield call(ApiRequest, favourites);

    if (response) {
      yield put({ type: SET_FAVOURITES_SUCCESS, data: response.data });

      if (onComplete) {
        onComplete({ data: response.data });
      }
    }
  } catch (error) {
    yield put({ type: SET_FAVOURITES_ERROR, favourites });

    if (onComplete) {
      onComplete({ error });
    }
  }
  return true;
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/user/flows/set-favourites-flow.ts